import { map } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

import { ProcessorFunction } from "./processor";
import { PropExpression } from './expressions';
import { DFSValueType } from './form';

export const $prop: ProcessorFunction<PropExpression, DFSValueType> = function(expression, scope, expressionManager) {
  return expressionManager.watch(expression.source, scope).pipe(
      map((source: any) => {
        const property = expression.property;

        if (!source || (typeof source !== 'object') || !source[property]) {
          return EMPTY;
        }

        return source[property as string] as DFSValueType;
      })
    );
};